import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Numerário',
    [PaymentMethodsEnum.Online]: 'Online',
    [PaymentMethodsEnum.InStoreCard]: 'Cartão na loja',
  },
};
